import React, { Fragment, Component } from 'react';
import skyscannerLogo from '../../assets/images/skyscanner-logo.svg';

class SkyscannerBanner extends Component {
	state = {};

	render() {
		const { hideSeparator = false } = this.props;

		return (
			<div className="skyscanner-banner">
				{hideSeparator ? <div className="hide-separator" /> : <div className="separator" />}
				<h2>COVID-19 Travel Info and Requirements</h2>
				<p>Review current travel entry guidelines, government measures, and more in Skyscanner.</p>
				<p className="note">We are not responsible for the accuracy of the content on Skyscanner. </p>
				{window.vaxihub ? (
					<a
						href="https://www.skyscanner.com.au"
						target="_blank"
						rel="noopener noreferrer"
						data-lightbox="leavesite"
						className="arrow-link"
					>
						View Travel Information
						<span className="arrow" />
					</a>
				) : (
					<a href="https://www.skyscanner.com.au" target="_blank" rel="noopener noreferrer" data-lightbox="leavesite">
						View Travel Information
					</a>
				)}
			</div>
		);
	}
}

export default SkyscannerBanner;
